module.exports = __webpack_public_path__ + "static/media/larr.755085f9.png";